import type { TUrlWithLocaleChannel } from '@boc/framework/urls/types';

import { urls } from '~/urls';

export interface Navigation {
  title: string | JSX.Element;
  to: TUrlWithLocaleChannel;
  children?: Navigation[];
}

export const navMain: Navigation[] = [];

export const navHeader: Navigation[] = [
  {
    title: 'Contact',
    to: urls.general.contact,
  },
  {
    title: 'About',
    to: urls.general.about,
  },
  {
    title: 'Track Order',
    to: urls.general.trackOrder,
  },
  {
    title: <img src="/static/kickstarter/icon.svg" alt="kickstarter Icon" />,
    to: urls.general.kickstarter,
  },
];
